import React from 'react'

export const NotFound = () => {
  return (
    <div>
      404
    </div>
  )
}
